import { Component, OnInit } from '@angular/core';
import { ForgotPasswordStateModel, ForgotPasswordSteps } from '../states/forgotPassword/forgot-password-state.model';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { AuthService } from '../services/account/auth.service';
import { MessageService } from 'primeng/api';
import { passwordValidator } from '../utility/passwordValidator';
import { loginResponse } from '../models/account/loginResponse';
import { validateEmailResponse } from '../models/account/validateEmailResponse';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ButtonModule, InputOtpModule, InputTextModule,DialogModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit{
 

  Step = ForgotPasswordSteps;
  currentStep: ForgotPasswordSteps = ForgotPasswordSteps.email;
  forgotPasswordState: ForgotPasswordStateModel | undefined;
  forgotPasswordForm: FormGroup | any;
  isUserExists: boolean = false;
  tempToken: string = '';
  disableContinueButton: boolean = false;

  loading: boolean = false;
  submitted: boolean = false;
  visible: boolean = false;

  constructor(
    private store: Store,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private messageService: MessageService,
  ){}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', Validators.pattern('[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$')],
      OTP: ['', Validators.required],
      password: [this.forgotPasswordState?.setPassword.password, [Validators.required, passwordValidator()]],
      confirmPassword: [this.forgotPasswordState?.setPassword.confirmPassword, Validators.required],
    }); 
  }

  continue() {
    this.submitted = true;
    this.disableContinueButton = true;
    if (this.currentStep == ForgotPasswordSteps.email) {
      console.log(this.forgotPasswordForm.email);
      this.authService.validateForgetPasswordEmail(this.forgotPasswordForm.value.email).subscribe({
        next: (response: validateEmailResponse) => {
          if (response.isAccountExists) {
            this.isUserExists = response.isAccountExists;
            // this.store.dispatch(new UpdateCurrentStep({ step: this.currentStep + 1 }));
            this.currentStep = this.currentStep + 1;
            this.submitted = false;
          }
          else {
            // this.store.dispatch(new UpdateEmailVerification({ email: this.forgotPasswordForm.value.email, emailVerified: false }));
            this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: "Email not found" });
            // this.router.navigate(['/signup']); // Adjust the path as needed
          }
          this.disableContinueButton = false;
          this.isUserExists = response.isAccountExists;
          this.loading = false;
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Unauthorized', detail: error });
          this.loading = false;
        },
        complete: () => {
          this.disableContinueButton = false;
          this.loading = false;
        }
      });
    }
    else if (this.currentStep == ForgotPasswordSteps.emailVerification) {
      this.submitted = true;
      this.disableContinueButton = false;
      const otpControl = this.forgotPasswordForm.get('OTP');
      if (otpControl && otpControl.errors) {
        return;
      }
      this.loading = true;
      // Verify OTP
      this.authService.verifyOTP({
        email: this.forgotPasswordForm.value.email,
        oTP: otpControl.value
      }).subscribe({
        next: (response) => {
          // this.store.dispatch(new UpdateEmailVerification({ email: this.forgotPasswordState?.emailVerification.email as string, emailVerified: true }));
          // this.store.dispatch(new UpdateTemporaryToken({ token: response.temporaryToken ?? "" }));
          // this.store.dispatch(new UpdateCurrentStep({ step: this.currentStep + 1 }));
          this.tempToken = response.temporaryToken ?? "";
          this.currentStep = this.currentStep + 1;
          this.loading = false;
          this.submitted = false;
          return;
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: error.name, detail: "Invalid OTP! Try again" });
          this.loading = false;
          return;
        }
      });

    }
    else if (this.currentStep ===ForgotPasswordSteps.setPassword) {
      this.submitted = true;
      this.disableContinueButton = false;
      const passwordControl = this.forgotPasswordForm.get('password');
      const confirmPasswordControl = this.forgotPasswordForm.get('confirmPassword');
      if (passwordControl && confirmPasswordControl) {
        const passwordErrors = passwordControl.errors;
        const confirmPasswordErrors = confirmPasswordControl.errors;

        if (passwordErrors || confirmPasswordErrors || passwordControl.value !== confirmPasswordControl.value) {
          return;
        }
      }
      // this.store.dispatch(new UpdateSetPassword({ password: passwordControl.value, confirmPassword: confirmPasswordControl.value }))
      this.authService.forgotPassword({
        newPassword: this.forgotPasswordForm.value.password || "",
        confirmPassword: this.forgotPasswordForm.value.confirmPassword || "",
        email: this.forgotPasswordForm.value.email || "",
        temporaryToken: this.tempToken || ""
      }).subscribe({
        next: (response: loginResponse) => {
          this.loading = false;
          localStorage.setItem("account", JSON.stringify(response));
          this.router.navigate(['/portal']);
        },
        error: (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: error.name, detail: error.message });
        }
      });
    }
  }

  showDialog() {
    this.visible = true;
  }
}
